import { render, staticRenderFns } from "./viewRequest.vue?vue&type=template&id=b3de31d0&scoped=true"
import script from "./viewRequest.vue?vue&type=script&lang=js"
export * from "./viewRequest.vue?vue&type=script&lang=js"
import style0 from "./viewRequest.vue?vue&type=style&index=0&id=b3de31d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3de31d0",
  null
  
)

export default component.exports